import React, { useRef, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Link, useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import validator from 'validator';
import axios from 'axios';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import { useContext } from 'react';
import { GlobalContext } from '../../../services/global/GlobalState';
import CircularProgress from '@material-ui/core/CircularProgress';
import LoginWithFacebook from '../login-with-social-media/LoginWithFacebook';
import { Box, IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { LoginGoogle } from '../login-with-social-media/login-google';
import { GoogleOAuthProvider } from '@react-oauth/google';
import useIsGuest from '../../../components/Hook/useIsGuest';
import { urlConfig } from '../../../config/urlConfig';
import { AuthenticationContext } from '../../../services/authentication/authentication.context';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.ui.secondary,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    color: theme.ui.secondary,
    textDecoration: 'none',
    backgroundColor: '#fff',
    marginRight: 3,
    marginLeft: 3,
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  caption: {
    margin: '6px',
    color: '#f44336',
  },
  signup_footer: {
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  wrapper: {
    margin: '10px 0',
    position: 'relative',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    width: 24,
  },
  other: {
    color: '#757575',
    fontWeight: 700,
    width: '100%',
    display: 'block',
    padding: '0.1px ',
    height: '100%',
    backgroundColor: '#7575752e',
  },
  otherText: {
    color: '#757575',
    margin: '0 6px',
    fontWeight: 500,
  },
  continue: {
    display: 'block',
    margin: '12px auto',
    color: '#757575',
  },
  singinText: {
    color: '#757575',
  },
  signUpGrid: {
    margin: 'auto',
  },
}));

export default function SignIn(props) {
  useIsGuest();
  const { expirationDate } = useContext(GlobalContext);
  const { setUserData, setUserPreferTime, getUserTimeZone } = useContext(
    AuthenticationContext
  );

  const classes = useStyles();
  const history = useHistory();
  const userNameRef = useRef(null);
  const passwordRef = useRef(null);
  const [username, setUserName] = useState('');
  const [userNameError, setUserNameError] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const submitHandler = (e) => {
    setUserData(null);
    setUserPreferTime(null);
    e.preventDefault();

    setPasswordError(false);
    setFormError('');

    if (validator.isEmpty(username)) {
      setUserNameError(true);
      userNameRef.current.focus();
    }

    if (validator.isEmpty(password)) {
      setPasswordError(true);
      if (!validator.isEmpty(username)) {
        passwordRef.current.focus();
      }
    }
    const data = {
      username: username.toLowerCase(),
      password: password,
    };
    let decode = '';

    if (username && password) {
      setLoading(true);
      axios
        .post(urlConfig.signIn_url, data)
        .then((response) => {
          localStorage.clear();
          setUserData(response.data.user);
          decode = jwt_decode(response.data.refresh_token);
          expirationDate(decode.exp);
          Cookies.set('access_token', response.data.access_token, {
            expires: 365,
            path: '/',
          });
          Cookies.set('refresh_token', response.data.refresh_token, {
            expires: 365,
            path: '/',
          });
          setLoading(false);
          Cookies.get('refresh_token') && getUserTimeZone();
          // const path = props.location.state;
          // console.log(path)
          // if (path) {
          //   console.log(path)
          //   history.push(props.location.state);
          // } else {
          //   console.log(path)
          // }
          history.push('/meetings');
        })
        .catch((err) => {
          setLoading(false);
          if (err.message) {
            setFormError(err.message);
          }
          if (err.response) {
            if (err.response.data && err.response.data.non_field_errors) {
              setFormError(err.response.data.non_field_errors);
            } else if (err.response.non_field_errors) {
              setFormError(err.response.non_field_errors);
            }
            if (
              err.response.data && err.response.data.detail &&
              err.response.data.detail === 'Verification-error'
            ) {
              history.push('/signin/verify-email');
            }
          }
        });
    }
  };

  return (
    <Container component='main' maxWidth='xs'>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Sign in
        </Typography>
        <form className={classes.form} noValidate onSubmit={submitHandler}>
          <TextField
            autoComplete='username'
            size='small'
            variant='outlined'
            margin='normal'
            required
            fullWidth
            id='username'
            label='Username or email address '
            name='username'
            error={userNameError}
            inputRef={userNameRef}
            onChange={(e) => {
              setUserName(e.target.value);
              setUserNameError(false);
            }}
            autoFocus
          />

          <TextField
            size='small'
            variant='outlined'
            margin='normal'
            fullWidth
            name='password'
            label='Password'
            className={classes.password}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
              style: {
                padding: 0,
              },
            }}
            id='password'
            helperText={
              <Typography variant='caption' color='error'>
                {formError}
              </Typography>
            }
            autoComplete='new-password'
            error={passwordError}
            inputRef={passwordRef}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordError(false);
            }}
            required
          />
          <Box mt={4} className={classes.wrapper}>
            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              disabled={loading}
              name='signIn'
              id='signIn'
            >
              Sign In
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Box>
          <Grid container className={classes.signup_footer}>
            <Grid item xs>
              <Button
                component={Link}
                to='/forget_password'
                size='small'
                p={0}
                className={classes.link}
              >
                Forgot password?
              </Button>
            </Grid>
            <Grid item className={classes.signUpGrid}>
              <Typography variant='caption' className={classes.singinText}>
                Don't have an account?
                <Link to='/signup' className={classes.link}>
                  Sign Up
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Box item display='flex' alignItems='center' m={2}>
            <span className={classes.other}></span>
            <Typography variant='caption' className={classes.otherText}>
              Or
            </Typography>
            <span className={classes.other}></span>
          </Box>

          <Box
            display='flex'
            flexDirection='column'
            justifyContent='center'
            mr='auto'
            ml='auto'
            width={270}
          >
            <GoogleOAuthProvider clientId={urlConfig.GOOGLE_API}>
              <LoginGoogle setFormError={setFormError} />
            </GoogleOAuthProvider>
            {/* <LoginWithTwitter setFormError={setFormError} /> */}
            {/* <LoginWithFacebook setFormError={setFormError} /> */}
          </Box>
        </form>
      </div>
    </Container>
  );
}
